export const formatDate = (date: Date | string) => {
  const formatter = new Intl.DateTimeFormat('cs-CZ', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })

  return formatter.format(new Date(date))
}
